module.exports = __webpack_public_path__ + "img/italiano.4fb1e807.svg";